<template>
<div class="list-question">
  <h2>
      <span class="no">
        {{index}}.
    </span>
    {{question}}

  </h2>

  <div class="input-list">
    <span
        v-for="option in options"
        :key="option.answer"
        :ref="'span'"
        @click="selectOptin(option)"
        :class="{'active': active(option)}"
    >{{option.answer}}</span>
  </div>
  <small>Select {{ inputType }}</small>

  <div class="btn-wrapper">
  <button class="btn btn-primary" @click="answered" v-if="validate">
    Next
  </button>
  </div>
</div>
</template>

<script>
export default {
  name: "ListQuestion.vue",
  props: {
    question: {
      type: String,
      required: true
    },
    options: {
      type: Array,
    },
    index: {
      type: Number,
      required: true
    },
    inputType: {
      type: String,
      default: 'text'
    },
    slide: {
      type: Number
    }
  },
  data(){
    return{
      ans:null,
      activeItem: 0
    }
  },
  methods: {
    active(option){
      if(this.inputType==='single'&& this.ans===option.answer) return true
      if(this.inputType==='multiple' && this.ans && this.ans.includes(option.answer)) return true
      return false
    },
    selectOptin(opt){
      if(this.inputType==='single')
      this.ans=opt.answer;
      else if(this.inputType==='multiple'){
        if(this.ans===null) this.ans=[]

        let index = this.ans.indexOf(opt.answer)
        if(index>-1){
          this.ans.splice(index, 1)
        }else{
          this.ans.push(opt.answer)
          }

      }

    },
    answered(){

      if (this.validate) {
        this.$emit('answered', {index: this.index, ans:this.ans, ques: this.question})
      }
    }
  },
  created() {
    document.addEventListener('keydown', (e)=>{
      try {
        if(this.index===this.slide)
          if(e.code==='Enter'){
            this.answered()
          }
      }catch(err) {
        console.log(err)
      }

    })
  },
  computed: {
    validate(){
      if(this.ans&&this.ans.length>0) return true
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
small {
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  display: block;
  padding-left: 28px;
  text-transform: capitalize;
   @media (max-width: 600px) {
    padding-left: 2px;
  }
}
.list-question {
h2 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  color: #52595E;
  margin-bottom: 16px;
  max-width: 375px;
  position: relative;
}
  .btn-wrapper{
    height: 78px;
  }
  .btn{
    margin-top: 33px;
    box-shadow: none;
    border-radius: 32px;
    text-transform: capitalize;
    letter-spacing:1px;
    padding: 10px 25px;
    margin-left: 26px;
    @media (max-width: 600px) {
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
    &:hover{
      background: #557efb;
      box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
    }
    &::after,
    &::before{
      content: none
    }
  }
.input-list {
  max-width: 470px;
  width: 100%;
  padding-left: 26px;
  @media (max-width: 600px) {
    padding-left: 0;
  }
  span{

    height:50px;
    width: 100%;
    margin-bottom: 12px;
    background: rgba(85, 126, 251, 0.74);
    border: 2px solid #557EFB;
    border-radius: 32px;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    color: #FFFFFF;
    padding-left: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover ,
    &:focus{
      background: #456bde;
    }
    &.active{
      background: #557EFB;
    }
  }

}


}
</style>
